import { benef_life_calendar_const } from "@constants/beneficiaryConstant";
import { dateFormate } from "@constants/index";
import dayjs from "dayjs";
import { getOngoingANCNumber } from "./commonUtils";

const handleCheckForPnc = (element: any) => {
    return dayjs(element.pregnancy_closure_date).add(45, 'day').isAfter(dayjs());
};

const toOrdinal = (number: any) => {
    const suffixes = ['th', 'st', 'nd', 'rd'];
    const v = number % 100;
    return number + (suffixes[(v - 20) % 10] || suffixes[v] || suffixes[0]);
};

export const handleForBenefRegistration = (value: any) => {
    const year = dayjs(value).year();
    const month = dayjs(value).format(dateFormate.onlyMonth);
    const pageType = benef_life_calendar_const.pregnancyStatus.registration;
    const title = 'Beneficiary Registration';
    const eventDate = dayjs(value).format(dateFormate.yyyy_mm_dd);
    return { year, month, pageType, title, eventDate }
};

export const handleForBenefDeath = (value: any) => {
    const year = dayjs(value.death_date).year();
    const month = dayjs(value.death_date).format(dateFormate.onlyMonth);
    const pageType = benef_life_calendar_const.pregnancyStatus.death;
    const title = `Death on ${dayjs(value.death_date).format(dateFormate.dd_mm_yyyy)}`
    const eventDate = dayjs(value.death_date).format(dateFormate.yyyy_mm_dd);
    return { year, month, pageType, title, eventDate }
};

export const handleForFamilyPlanning = (element: any) => {
    const year = dayjs(element.family_planning_service_date).year();
    const month = dayjs(element.family_planning_service_date).format(dateFormate.onlyMonth);
    const pageType = benef_life_calendar_const.pregnancyStatus.family_planning;
    const title = `Family Planning (${dayjs(element.family_planning_service_date).format(dateFormate.dd_mm_yyyy)})`;
    const subtitle = `${element.family_planning_category_name ? element.family_planning_category_name : ''}${element.family_planning_method_name ? `, ${element.family_planning_method_name}` : ''}`;
    const eventDate = dayjs(element.family_planning_service_date).format(dateFormate.yyyy_mm_dd);
    return { year, month, pageType, title, subtitle, eventDate }
};

export const handleForAborTion = (element: any) => {
    const year = dayjs(element.pregnancy_closure_date).year();
    const month = dayjs(element.pregnancy_closure_date).format(dateFormate.onlyMonth);
    const pageType = benef_life_calendar_const.pregnancyStatus.abortion;
    const title = [`${toOrdinal(element.pregnancy_order)} Pregnancy on (${dayjs(element.pregnancy_reg_dt).format(dateFormate.dd_mm_yyyy)})`, `${element.is_hrp ? 'HRP' : ''}`, `${handleCheckForPnc(element) ? 'Ongoing PNC' : ''}`].filter((item: any) => item !== '').join(', ');
    const subtitle = `Abortion (${dayjs(element.pregnancy_closure_date).format(dateFormate.dd_mm_yyyy)})`;
    const pregnancyId = element.pregnancy_id;
    const eventDate = dayjs(element.pregnancy_closure_date).format(dateFormate.yyyy_mm_dd);
    return { year, month, pageType, title, subtitle, pregnancyId, eventDate }
};

export const handleForDelivery = (element: any) => {
    const year = dayjs(element.pregnancy_closure_date).year();
    const month = dayjs(element.pregnancy_closure_date).format(dateFormate.onlyMonth);
    const pageType = element.pregnancy_status_code === benef_life_calendar_const.pregnancyStatus.success ? benef_life_calendar_const.pregnancyStatus.success : benef_life_calendar_const.pregnancyStatus.still_birth;
    const title = [`${toOrdinal(element.pregnancy_order)} Pregnancy on (${dayjs(element.pregnancy_reg_dt).format(dateFormate.dd_mm_yyyy)})`, `${element.is_hrp ? 'HRP' : ''} (Delivery Date: ${dayjs(element.pregnancy_closure_date).format(dateFormate.dd_mm_yyyy)})`, `${handleCheckForPnc(element) ? 'Ongoing PNC' : ''}`].filter((item: any) => item !== '').join(', ');
    const subtitle = [`${element.no_of_still_birth ? element.no_of_still_birth + ' Still Birth' : ''}`, `${element.no_of_live_birth ? element.no_of_live_birth + ' Live Birth' : ''}`].filter((item: any) => item !== '').join(', ');
    const pregnancyId = element.pregnancy_id;
    const eventDate = dayjs(element.pregnancy_closure_date).format(dateFormate.yyyy_mm_dd);
    return { year, month, pageType, title, subtitle, pregnancyId, eventDate }
};

export const handleForOnGoingPregnancy = (element: any) => {
    const ancPeriod = getOngoingANCNumber(element.lmp_date);                
    const ancNo = ancPeriod?.anc;
    const ancLabel = ancNo ? `Ongoing ANC ${ancNo}` : 'Ongoing ANC';
    const year = dayjs().year();
    const month = dayjs().format(dateFormate.onlyMonth);
    const pageType = benef_life_calendar_const.pregnancyStatus.on_going;
    const title = [`${toOrdinal(element.pregnancy_order)} Pregnancy on (${dayjs(element.pregnancy_reg_dt).format(dateFormate.dd_mm_yyyy)})`, `${element.is_hrp ? 'HRP' : ''}`, ancLabel].filter((item: any) => item !== '').join(', ');
    const subtitle = 'Ongoing Pregnancy';
    const eventDate = dayjs().format(dateFormate.yyyy_mm_dd);
    return { year, month, pageType, title, subtitle, eventDate }
};